import CustomTooltip from "components/Common/Tooltip/CustomTooltip";
import styles from "./index.module.scss";

export default function SideMenu({menus, selectedMenu, handleSelectedMenu}) {
  return (
    <div className={styles.container}>
      <div className={styles.items}>
        {menus.map(item => {
          const {iconDefault, iconSelected, name} = item;
          return (
            <CustomTooltip description={name} placement={"left"}>
              <div
                className={`${styles.item} ${selectedMenu === name ? styles.selected : ""}`}
                onClick={() => handleSelectedMenu(name)}
                key={name}
              >
                {selectedMenu === name ? iconSelected : iconDefault}
              </div>
            </CustomTooltip>
          );
        })}
      </div>
    </div>
  );
}
